import { useAnalytics } from 'hooks/use-analytics/useAnalytics'
import { useProfilePercentage } from 'hooks/use-profile-percentage/useProfilePercentage'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { IMainWrapperProps } from '../MainWrapper'

export const useMainWrapper = ({ showSearch }: IMainWrapperProps) => {
  const { isAuthenticated, backendUser, backendPartner } = useAuth()
  const { isDevice, isTablet } = useScreenSizes()

  const { getProfilePercentage } = useProfilePercentage()
  const { logEventAnalytics } = useAnalytics()

  const canSearch = (isDevice || isTablet) && showSearch && isAuthenticated

  return {
    isAuthenticated,
    backendUser,
    backendPartner,
    isDevice,
    isTablet,
    getProfilePercentage,
    logEventAnalytics,
    canSearch
  } as const
}
